import { QRCodeSVG } from "qrcode.react";

export const RecordQrPanel = () => {
  const url = `${window.location.origin}/record`;
  return (
    <div className="space-y-4 rounded-3xl border border-slate-200 bg-white p-6" data-testid="record-qr-panel">
      <ol className="list-decimal space-y-1 pl-5 text-sm text-slate-600">
        <li>Open the Camera on your iPhone and scan this code.</li>
        <li>Enter the staff passcode (admins can see it under Administrators).</li>
        <li>Record upright, 2 minutes max, then tap Send.</li>
      </ol>
      <div className="mx-auto w-fit rounded-2xl bg-white p-3 shadow-inner" data-testid="record-qr-code"><QRCodeSVG value={url} size={220} fgColor="#0A3A6B" level="M" /></div>
      <p className="break-all text-center text-xs text-slate-400">{url}</p>
      <p className="text-center text-xs text-slate-500">The video lands in the list on the right as Pending for approval.</p>
    </div>
  );
};
